/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDeliverableInvoiceResource
 */
export interface ProjectDeliverableInvoiceResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectDeliverableInvoiceResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDeliverableInvoiceResource
     */
    type: ProjectDeliverableInvoiceResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectDeliverableInvoiceResource
     */
    url: string;
}


/**
 * @export
 */
export const ProjectDeliverableInvoiceResourceTypeEnum = {
    Service: 'SERVICE',
    Fees: 'FEES'
} as const;
export type ProjectDeliverableInvoiceResourceTypeEnum = typeof ProjectDeliverableInvoiceResourceTypeEnum[keyof typeof ProjectDeliverableInvoiceResourceTypeEnum];


/**
 * Check if a given object implements the ProjectDeliverableInvoiceResource interface.
 */
export function instanceOfProjectDeliverableInvoiceResource(value: object): value is ProjectDeliverableInvoiceResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ProjectDeliverableInvoiceResourceFromJSON(json: any): ProjectDeliverableInvoiceResource {
    return ProjectDeliverableInvoiceResourceFromJSONTyped(json, false);
}

export function ProjectDeliverableInvoiceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDeliverableInvoiceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'url': json['url'],
    };
}

export function ProjectDeliverableInvoiceResourceToJSON(value?: ProjectDeliverableInvoiceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'url': value['url'],
    };
}

